import { DefaultState, TableFilters } from 'store/reducers/types';

export const READ_JOB_LIST_FILTERS_REQUEST = 'READ_JOB_LIST_FILTERS_REQUEST';
export const READ_JOB_LIST_FILTERS_SUCCESS = 'READ_JOB_LIST_FILTERS_SUCCESS';
export const READ_JOB_LIST_FILTERS_FAILURE = 'READ_JOB_LIST_FILTERS_FAILURE';

export type JobListFiltersState = DefaultState & {
  contents?: TableFilters;
};

interface ReadJobListFiltersRequest {
  type: typeof READ_JOB_LIST_FILTERS_REQUEST;
};

interface ReadJobListFiltersSuccess {
  type: typeof READ_JOB_LIST_FILTERS_SUCCESS,
  contents: TableFilters;
};

interface ReadJobListFiltersFailure {
  type: typeof READ_JOB_LIST_FILTERS_FAILURE;
};

export type JobListFiltersActionTypes = ReadJobListFiltersRequest | ReadJobListFiltersSuccess | ReadJobListFiltersFailure;